import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';
import { Injectable } from '@angular/core';
import { DeviceProvider } from '@core-modules/providers/device/device';
import { CoreConfiguration } from '../../../app/providers/core-configuration';

/**
 * Guard Preventing access to the page unless the platform is an application
 */
@Injectable()
export class PinLoginPageGuard 
{
    /**
     * Class constructor
     * @param config
     * @param navCtrl
     * @param device
     */
    constructor
        (
            private config: CoreConfiguration,
            private router: Router,
            private device: DeviceProvider
        )
    {

    }

    /**
     * CanActivate method implementation, returning true if the page can
     * be accessed or a URL tree if a redirection has to be done.
     * Will return true only if the application is running within a Capacitor context
     * and a login token is available
     * @param next
     * @param state
     */
    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        let loginToken = (await this.config.getApplicationState()).LoginToken;
        if (this.device.isApplication() && loginToken)
        {
            return true;
        }
        else
        {
            return this.router.parseUrl('/landing');
        }
    }
}